<!--
  @Description 导航列表
  @Date 2021-12-23
  @Author liufu
-->
<template>
  <div style="height: 100%">
    <!-- 标题 -->
    <div class="nav-list-title">{{ title }}</div>

    <!-- 列表 -->
    <div class="nav-list">
      <div
        class="nav-item"
        :class="[indexValue === String(item[indexKey]) ? 'is-active-item' : '']"
        v-for="(item, index) of listData"
        :key="index"
        @click.stop="itemClick(item, index)"
      >
        <div class="nav-item__name">
          {{ item[listKey] }}
        </div>
        <div class="nav-item__img">
          <img
            src="@/assets/img/arrow-left.png"
            v-if="indexValue === String(item[indexKey])"
          />
        </div>
      </div>
    </div>

    <!-- 无数据 -->
    <div class="null-data" v-if="!listData.length">暂无数据</div>
  </div>
</template>

<script>
export default {
  name: 'navList',
  props: {
    // 列表数据
    listData: {
      type: Array,
      default: () => {
        return []
      }
    },
    // 标题
    title: {
      type: String,
      default: ''
    },
    // 显示字段key
    listKey: {
      type: String,
      default: 'name'
    },
    // 对应list obj中的key
    indexKey: {
      type: String,
      default: ''
    },
    // 选中的值(如果为id等数值需要String()处理)
    indexValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
    }
  },
  methods: {
    // 列表项点击事件
    itemClick(item) {
      if (this.indexValue === String(item[this.indexKey])) {
        return
      }
      this.$emit('itemClick', item)
    },
  }
}
</script>

<style lang="less" scoped>
.nav-list-title {
  height: 35px;
  width: 100%;
  box-sizing: border-box;
  padding-left: 10px;
  background-color: #f8f8f9;
  color: #444;
  .fl(flex,flex-start,center);
}

.nav-list {
  height: 100%;
  overflow-y: scroll;
}
.nav-list::-webkit-scrollbar {
  display: none;
}

.nav-item {
  box-sizing: border-box;
  width: 93%;
  min-height: 40px;
  padding: 10px 20px;
  margin: 8px auto;
  transition: @normal-transition;
  border-radius: 5px;
  .fl(flex, flex-start, center);
}

.nav-item:hover {
  cursor: pointer;
  background-color: #e3ecfb;
  transition: @normal-transition;
}

.nav-item__name {
  width: 80%;
}

.is-active-item {
  background-color: #e3ecfb;
  color: #6c9eff;
  transition: @normal-transition;
  position: relative;
  // justify-content: space-between;

  // .nav-item__name {
  //   width: 80%;
  // }
  .nav-item__img {
    width: 20px;
    position: absolute;
    right: 5px;
    // 箭头
    > img {
      width: 15px;
      height: 12px;
    }
  }
}

.null-data {
  font-size: 12px;
  color: #606266;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
